module.exports = __webpack_public_path__ + "img/horizontal_6_4_8023.f84547b4.png";